import { render, staticRenderFns } from "./ppsz.vue?vue&type=template&id=00ae5e46&scoped=true&"
import script from "./ppsz.vue?vue&type=script&lang=js&"
export * from "./ppsz.vue?vue&type=script&lang=js&"
import style0 from "./ppsz.vue?vue&type=style&index=0&id=00ae5e46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ae5e46",
  null
  
)

export default component.exports